"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var isString = require("lodash/isString");
var isArray = require("lodash/isArray");
var _ = { isString: isString, isArray: isArray };
var PanelBaseHeader = function (props) {
    var header = props.header, type = props.type;
    if (!header) {
        return null;
    }
    var elemHeader;
    if (_.isString(header)) {
        var classNameHeader = classNames(type + "__header");
        elemHeader = (React.createElement("div", { className: classNameHeader },
            React.createElement("h3", null, header)));
    }
    else if (_.isArray(header)) {
        var classNameHeader = classNames(type + "__header", type + "__header--with-actions");
        var elemHeaderString = header[0];
        var elemHeaderActions = header[1];
        elemHeader = (React.createElement("div", { className: classNameHeader },
            _.isString(elemHeaderString) ? (React.createElement("h3", null, elemHeaderString)) : (elemHeaderString),
            elemHeaderActions));
    }
    else {
        var classNameHeader = classNames(type + "__header", type + "__header--only-actions");
        elemHeader = React.createElement("div", { className: classNameHeader }, header);
    }
    return elemHeader;
};
var PanelBaseFooter = function (props) {
    var footer = props.footer, type = props.type;
    if (!footer) {
        return null;
    }
    var footerWithActionsClass = type + "__footer--with-actions";
    var classNameFooter = classNames(type + "__footer", {
        footerWithActionsClass: _.isArray(footer)
    });
    return React.createElement("footer", { className: classNameFooter }, footer);
};
var PanelBase = /** @class */ (function (_super) {
    __extends(PanelBase, _super);
    function PanelBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMaskClick = function (e) {
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose(e);
            }
        };
        return _this;
    }
    PanelBase.prototype.render = function () {
        // FIXME: (Xinyang) `PanelBaseProps` has to update to make destructuring assignment below valid
        var _a = this.props, children = _a.children, className = _a.className, footer = _a.footer, header = _a.header, id = _a.id, open = _a.open, style = _a.style, type = _a.type, mask = _a.mask, onRequestClose = _a.onRequestClose;
        var classNameContainer = classNames(className);
        var classNameContent = classNames(type + "__content");
        var elemBase, elemMask;
        elemBase = (React.createElement("article", { className: classNameContainer, id: id, style: style },
            React.createElement(PanelBaseHeader, { header: header, type: type }),
            React.createElement("div", { className: classNameContent }, children),
            React.createElement(PanelBaseFooter, { footer: footer, type: type })));
        if (mask &&
            (type === 'sheet' || type === 'panel' || type === 'side-panel')) {
            var classNamesMask = classNames(type + "__mask", open ? type + "__mask--current" : '');
            elemMask = (React.createElement("div", { className: classNamesMask, onClick: this.handleMaskClick }));
        }
        return (React.createElement("div", { style: { position: 'relative' } },
            elemBase,
            elemMask));
    };
    PanelBase.defaultProps = {
        mask: true
    };
    return PanelBase;
}(React.Component));
exports.default = PanelBase;
//# sourceMappingURL=PanelBase.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Panel/PanelBase.js
// module id = 31
// module chunks = 0